<template>
  <v-container v-if="!containerInitLoading && supplier" fluid style="height: inherit">
    <v-row align="stretch" style="height: inherit;">
      <v-col>
        <SupplierDetails :supplier="supplier" :saveMethod="saveChanges" :readonly="SupplierReadonly">
        </SupplierDetails>
      </v-col>

      <template v-if="ProductPortalEnabled">
        <v-divider vertical style="z-index: 1;" />

        <v-col style="background-color: rgb(248, 248, 248) !important;">
          <SupplierSyncDetails :supplier="supplier" :saveMethod="saveChanges" :readonly="SupplierReadonly">
          </SupplierSyncDetails>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SupplierDetails from "./SupplierDetails.vue";
import SupplierSyncDetails from "./SupplierSyncDetails.vue";

export default {
  name: "ViewSupplierInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    SupplierDetails,
    SupplierSyncDetails,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      const dto = Object.assign({}, obj);
      await this.updateSupplier(dto)
        .then((response) => {
          this.supplier = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },
  },

  computed: {
    supplier: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

    ProductPortalEnabled() {
      return !!this.$store.state.GlobalSettings.ProductPortalSettings;
    },

  },

  watch: {

  },
};
</script>


<style lang='scss'></style>